import { TranslationsContext } from '@teliaee/telia-translate';
import { observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { ISuggestionItem, LargeSearch, Notice, SuggestionField } from 'telia-front-react';
import RoamingNumberStore from '../stores/RoamingNumberStore';
import { NumberSuggestion } from './RoamingInterfaces';

interface RoamingNumberSearchProps {
  roamingNumberStore?: RoamingNumberStore;
}

@observer
class RoamingNumberSearch extends React.Component<RoamingNumberSearchProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;

  @observable accessor submitted: boolean = false;

  public componentDidMount() {
    this.props.roamingNumberStore.subscribe();
  }

  public componentWillUnmount() {
    this.props.roamingNumberStore.unsubscribe();
  }

  public render() {
    const translate = this.context.translate;
    const { roamingNumberStore } = this.props;
    if (roamingNumberStore.isCountryListLoading) {
      return null;
    }
    if (roamingNumberStore.countryList.status === 'FAILED') {
      return <Notice type="error">{translate('general.error.message')}</Notice>;
    }
    return (
      <>
        <LargeSearch
          id="roaming-number-large-search"
          align="center"
          formAttributes={{
            onSubmit: (e) => {
              e.preventDefault();
              this.submitted = true;
              roamingNumberStore.handleSubmit().then(() => (this.submitted = false));
            }
          }}
        >
          <SuggestionField
            id="roaming-number-search"
            label={translate('roamingNumberSearch.placeholder')}
            items={roamingNumberStore.numberSuggestionItems}
            value={roamingNumberStore.numberSuggestionSearchTerm}
            onChange={(input: string) => roamingNumberStore.handleInputChange(input)}
            onSelect={(selectedItem: ISuggestionItem) => roamingNumberStore.selectNumberSuggestionItem(selectedItem as NumberSuggestion)}
            isDisabled={roamingNumberStore.isCountryListLoading || this.submitted}
            image={roamingNumberStore.selectedCountryImage}
            placeholderLabel={true}
            input={{ autoComplete: 'off' }}
          />
        </LargeSearch>
      </>
    );
  }
}

export default inject('roamingNumberStore')(RoamingNumberSearch);
